import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ConfigProvider } from './contexts/ConfigContext';
import LoginPage from './pages/LoginPage';
import InspectionsList from './pages/InspectionsList';
import InspectionUpload from './pages/InspectionUpload';
import InspectionDetail from './pages/InspectionDetail';
import ComparisonPage from './pages/ComparisonPage';
import ConfigPage from './pages/ConfigPage';
import InspectionDevView from './pages/InspectionDevView';
import ImageTestPage from './pages/ImageTestPage';
import InspectionV2Real from './pages/InspectionV2Real';
import InspectionV3 from './pages/InspectionV3';

function AppContent() {
  const { isAuthenticated, loading } = useAuth();
  const [forceLogin] = useState(false);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-louca-dark">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500 mx-auto"></div>
          <p className="mt-4 text-gray-400">Chargement...</p>
        </div>
      </div>
    );
  }

  return (
    <Router basename="/louca.ai">
      <Routes>
        <Route
          path="/login"
          element={
            isAuthenticated && !forceLogin ? (
              <Navigate to="/inspections" replace />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/inspections"
          element={
            isAuthenticated ? <InspectionsList /> : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/upload"
          element={
            isAuthenticated ? <InspectionUpload /> : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/inspection/:id"
          element={
            isAuthenticated ? <InspectionDetail /> : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/inspection/:id/dev"
          element={
            isAuthenticated ? <InspectionDevView /> : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/compare"
          element={
            isAuthenticated ? <ComparisonPage /> : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/config"
          element={
            isAuthenticated ? <ConfigPage /> : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/test/image"
          element={
            isAuthenticated ? <ImageTestPage /> : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/test/v2"
          element={
            isAuthenticated ? <InspectionV2Real /> : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/test/v3"
          element={
            isAuthenticated ? <InspectionV3 /> : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/"
          element={<Navigate to={isAuthenticated ? "/inspections" : "/login"} replace />}
        />
      </Routes>
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <ConfigProvider>
        <AppContent />
      </ConfigProvider>
    </AuthProvider>
  );
}

export default App;



